// extracted by mini-css-extract-plugin
var _1 = "TableTitleCell-moduleadditionalInfoContainer__wE7im";
var _2 = "TableTitleCell-moduleavatar__ahBoK";
var _3 = "TableTitleCell-moduletitle__jy_q8";
var _4 = "TableTitleCell-modulewithNote__Qa7vb";
export { _1 as "additionalInfoContainer", _2 as "avatar", _3 as "title", _4 as "withNote" }
